module.exports = __webpack_public_path__ + "static/media/fal_fal_wor_war.8a4db62f.png";